module.exports = __webpack_public_path__ + "img/analysis.622c360f.png";